import { Outlet } from 'react-router-dom'

const MCUControlPage = () => {
    return (
        <Outlet />
    )
}

export default MCUControlPage